import React from 'react';
// const ProductBannerText = lazy(() => import('./ProductBannerText'));
// const ProductBannerVideo = lazy(() => import('./ProductBannerVideo'));
import ProductBannerText from './ProductBannerText';
import ProductBannerVideo from './ProductBannerVideo';

const ProductBanner: React.FC = () => {
  return (
    <main className="mt-10 max-w-7xl sm:mt-12 md:mt-16 lg:mt-20 xl:mt-28  grid grid-cols-1 lg:grid-cols-6 gap-6">
      <ProductBannerText />
      <ProductBannerVideo />
    </main>
  );
};

export default ProductBanner;
